export const SET_AVERAGE_HEALTHSCORE_LOADING = 'SET_AVERAGE_HEALTHSCORE_LOADING';
export const SET_AVERAGE_HEALTHSCORE_WIDGET_RESULTS = 'SET_AVERAGE_HEALTHSCORE_WIDGET_RESULTS';
export const SET_AVERAGE_HEALTHSCORE_DETAILS_LOADING = 'SET_AVERAGE_HEALTHSCORE_DETAILS_LOADING';
export const SET_AVERAGE_HEALTHSCORE_DETAILS_RESULTS = 'SET_AVERAGE_HEALTHSCORE_DETAILS_RESULTS';
export const SET_AVERAGE_HEALTHSCORE_DETAILS_PAGINATION = 'SET_AVERAGE_HEALTHSCORE_DETAILS_PAGINATION';
export const SET_AVERAGE_HEALTHSCORE_DETAILS_HIDDEN_CLIENT_COUNT = 'SET_AVERAGE_HEALTHSCORE_DETAILS_HIDDEN_CLIENT_COUNT';
